import React, { useContext, useState, useEffect } from 'react'
import classNames from 'classnames'
import qs from 'qs'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import request from 'meinian-package/src/utils/request'
import util from 'meinian-package/src/utils/util'
import { MEMBER_TYPE } from 'meinian-package/src/component/enum'
import NotAllow from './notallow'
import ManagementSetting from './managementSetting'
import useViewSettingModal from './viewSettingModal'
import { AccountContext } from '../../context'
import './index.less'

const roles = {
  20: '尊享版',
  5: '专业版',
  7: '进阶版',
  6: '基础版',
  24: '标准版',
  25: '旗舰版',
  11: '内部版'
}

export default ({ style }) => {
  const { teamInfo = {}, userInfo = {} } = useContext(AccountContext)
  const [visible, setVisible] = useState(false)
  const [notAllowVisible, setNotAllowVisible] = useState(false)
  const [managementSettingVisible, setManagementSettingVisible] = useState(false)
  const { name, userPhone, userAuthCodeList, avatar } = userInfo
  const { teamName, memberType, memberUpperLimit, serviceEndTime, roleId } = teamInfo
  const expiredTime = serviceEndTime
  const path = window.location.pathname

  useEffect(() => {
    if (userPhone) localStorage.userPhone = userPhone
  }, [visible])

  const logout = () => {
    request.get('/backend-api/sso-auth/auth/logout')
    localStorage.clear()
    util.setCookie(process.env.REACT_APP_TOKEN, '', -1)
    window.location.href = '/login'
    util.track('mn-header-link', {
      module1: '顶部导航',
      module2: '用户设置',
      module3: '退出登录',
    })
  }

  const jumpToTeam = () => {
    // 监听灵感集领取地址，跳转到美念
    if (window.location.pathname === '/meinian/receive') {
      const query = qs.parse(location.search, { ignoreQueryPrefix: true })
      return location.href = `/meinian/receive?${qs.stringify(query)}`
    }
    const token = util.getCookie(process.env.REACT_APP_TOKEN)
    if (!token || token === 'undefined') {
      return window.location = `/login#${window.location.pathname + window.location.search}`
    }
    util.track('mn-header-link', {
      module1: '顶部导航',
      module2: '用户设置',
      module3: '团队设置',
    })
    window.open('/team')
  }

  const title = (
    <>
      <div className="user-info-item" style={{ cursor: 'default' }}>
        <div className="info-title line-1">{name}</div>
        <div className="info-description">{userPhone}</div>
      </div>
      <div className="user-info-item" style={{ cursor: 'default' }}>
        <div className="info-title line-1" style={{ width: memberType !== MEMBER_TYPE.SUPER_ADMIN ? '120px' : '100%' }}>{teamName}{memberType !== MEMBER_TYPE.SUPER_ADMIN ? <div className="user-role">{roles[roleId]}</div> : null}</div>
        <div className="info-description" style={{ color: util.isExpire30(expiredTime) ? '#ff5555' : 'var(--m-text-3)' }}>
          {util.getFormatDate(expiredTime, 'YYYY-MM-DD')}到期{util.getLimitDate(expiredTime)}
        </div>
      </div>
    </ >)

  const content = (
    <div className="meinian-user-info-wrap">
      {title}
      <div>
        {path === '/loginGuide' ? null : <>
          <div className="info-line" />
          <div className={classNames({ 'no-center': userAuthCodeList ? !(userAuthCodeList.indexOf('personal_center') > -1) : '' })}>
            <a
              className="user-info-item"
              style={{ cursor: 'pointer' }}
              href="/account"
              target="_self"
              onClick={() => {
                util.track('mn-header-link', {
                  module1: '顶部导航',
                  module2: '用户设置',
                  module3: '个人设置',
                })
              }}
            >
              <div className="info-title">个人设置</div>
            </a>
            <div className="user-info-item" style={{ cursor: 'pointer' }} onClick={() => jumpToTeam()}>
              <div className="info-title">团队设置</div>
            </div>
          </div>
          {
            [MEMBER_TYPE.SUPER_ADMIN, MEMBER_TYPE.ADMIN].includes(Number(teamInfo?.memberType)) && <a
              className="user-info-item"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                util.track('mn-header-link', {
                  module1: '顶部导航',
                  module2: '用户设置',
                  module3: '美念管理',
                })
                setManagementSettingVisible(true)
                setVisible(false)
              }}
            >
              <div className="info-title">美念管理</div>
            </a>
          }
          <a
            className="user-info-item"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              util.track('mn-header-link', {
                module1: '顶部导航',
                module2: '用户设置',
                module3: '视图设置',
              })
              useViewSettingModal({})
            }}
          >
            <div className="info-title">视图设置</div>
          </a>
          {/* <div className={classNames({ 'no-center': userAuthCodeList ? !(userAuthCodeList.indexOf('personal_center') > -1) : '' })}>
            <div className="info-line" />
            <a
              className="user-info-item"
              style={{ cursor: 'pointer' }}
              href="/downloadExcelList"
              target="_self"
              onClick={() => {
                util.track('mn-header-link', {
                  module1: '顶部导航',
                  module2: '用户设置',
                  module3: '导出列表',
                })
              }}
            >
              <div className="info-title">导出列表</div>
            </a>
            <a
              className="user-info-item"
              style={{ cursor: 'pointer' }}
              href="/downloadclient"
              target="_blank"
              onClick={() => {
                util.track('mn-header-link', {
                  module1: '顶部导航',
                  module2: '用户设置',
                  module3: '导表客户端',
                })
              }}
            >
              <div className="info-title">导表客户端</div>
            </a>
          </div> */}
        </>}
        <div className="info-line" />
        <a
          className="user-info-item"
          style={{ cursor: 'pointer', padding: '14px 16px' }}
          href="/dataExplain"
          onClick={() => {
            util.track('mn-header-link', {
              module1: '顶部导航',
              module2: '用户设置',
              module3: '常见问题',
            })
          }}
        >
          <div className="info-title">常见问题</div>
        </a>
      </div>
      <div className="info-line" />
      <div className={classNames('user-info-item', { logout: true })} style={{ cursor: 'pointer', }} onClick={() => logout()}>
        <div className="info-title">退出登录</div>
      </div>
    </div>)
  return <div className="meinian-user-info">
    <Dropdown
      placement="bottomRight"
      overlayClassName="meinian-user-info-dropdown"
      overlay={content}
      trigger="click"
      visible={visible}
      onVisibleChange={_visible => { setVisible(_visible) }}
    >
      <Tooltip title="用户设置">
        <div className={classNames('icon-button-wrap')} style={{ ...style, marginLeft: 16 }}>
          <img src={avatar} className="icon-button-wrap-avatar" />
        </div>
      </Tooltip>
    </Dropdown>
    <NotAllow
      visible={notAllowVisible}
      title="团队人数已经满啦"
      desc={`尊敬的用户，你当前所使用的版本最多只支持${memberUpperLimit}人协作。如需升级版本，请扫描下方二维码，我们将尽快为你处理`}
      onCancel={() => {
        setNotAllowVisible(false)
      }}
    />
    <ManagementSetting
      visible={managementSettingVisible}
      onClose={() => setManagementSettingVisible(false)}
      onVisibleChange={vis => setManagementSettingVisible(vis)}
    />
  </div>
}
